import { render, staticRenderFns } from "./PreviewTerms.vue?vue&type=template&id=0d8f13bf"
import script from "./PreviewTerms.vue?vue&type=script&lang=js"
export * from "./PreviewTerms.vue?vue&type=script&lang=js"
import style0 from "./PreviewTerms.vue?vue&type=style&index=0&id=0d8f13bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports